import React, { useState } from 'react';
import { FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faBan, faSave, faTrashAlt, faEnvelope, faCommentDots, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { getShortDate, getInputDate, addMinutesToDateTime } from '../../Helper';
import YesNoModal from '../YesNoModal';

function FeeCommentCard(props) {
    const [editMode, setEditMode] = useState(false);
    const [feeComment, setFeeComment] = useState(props.feeComment);
    const [deletionConfirmationModal, setDeletionConfirmationModal] = useState(false);

    const toggleDeletionConfirmationModal = () => setDeletionConfirmationModal(!deletionConfirmationModal);

    const updateComment = (e) => {
        console.log('Updating fee comment...');
        let value = e.target.value;
        switch (e.target.type) {
            case "number":
                value = e.target.valueAsNumber;
                break;
            case "date":
                value = new Date(e.target.value + 'T00:00');
                break;
        }
        setFeeComment({ ...feeComment, [e.target.name]: value });
    };

    const cancel = () => {
        setFeeComment(props.feeComment);
        setEditMode(false);
    };

    const save = () => {
        console.log('Saving fee comment...');
        props.save(feeComment);
        setEditMode(false);
    };

    const deleteComment = () => {
        console.log("Deleting comment: " + JSON.stringify(props.feeComment));
        props.delete(props.feeComment.feeCommentID);
    };

    const editComment = () => {
        setEditMode(true);
    }

    const feeCommentJSX = (
        <div className="role-fee-comment card item-details">
            <div className="properties">
                <div className="svg-label comments">
                    <i className="fas fa-comment-dots"></i>
                    <span>{props.feeComment.comment}</span>
                </div>
                <div className="svg-label">
                    <i className="fas fa-calendar-alt"></i>
                    <span>{getShortDate(props.feeComment.commentDate)}</span>
                </div>
            </div>
            {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                <div className="actions-horizontal">
                    <div onClick={editComment} className="action-icon action-edit">
                        <FontAwesomeIcon icon={faEdit} />
                    </div>
                    <div onClick={toggleDeletionConfirmationModal} className="action-icon action-delete">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                </div>
            ) : null}
            <YesNoModal title="Confirm Deletion" yesClick={deleteComment} open={deletionConfirmationModal} toggle={toggleDeletionConfirmationModal}>Are you sure you want delete this Comment?</YesNoModal>
        </div>
    );

    const editFeeCommentJSX = (
        <div className="feeComment card  item-details">
            <div className="properties">
                <InputGroup className="comments">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <FontAwesomeIcon icon={faCommentDots} />
                        </InputGroupText>
                    </InputGroupAddon>
                    <textarea placeholder="Comment" name="comment" value={feeComment.comment || ''} onChange={updateComment} />
                </InputGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <FontAwesomeIcon icon={faCalendarAlt} />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input type="date" placeholder="Comment Date" name="commentDate" value={getInputDate(feeComment.commentDate) || ''} onChange={updateComment} />
                </InputGroup>
            </div>
            <div className="actions-horizontal">
                <div onClick={cancel} className="action-icon action-delete">
                    <FontAwesomeIcon icon={faBan} />
                </div>
                <div onClick={save} className="action-icon action-add">
                    <FontAwesomeIcon icon={faSave} />
                </div>
            </div>
        </div>
    );

    return editMode ? editFeeCommentJSX : feeCommentJSX;
}

export default FeeCommentCard;